import { createEffect, onCleanup, Show } from "solid-js"
import { createStore } from "solid-js/store"
import { useLanguage } from "@/context/language"
import { reportPreviewPath } from "@/cowork/report-preview"
import "@/cowork/report-workspace.css"

export function ReportPreviewLink(props: { projectID: string; artifactID: string; companyID: string }) {
  return <CopyableReportLink href={reportPreviewPath(props.projectID, props.artifactID, props.companyID)} />
}

export function CopyableReportLink(props: { href: string; review?: boolean }) {
  const language = useLanguage()
  const [store, setStore] = createStore({ copied: false, failed: false })
  let mounted = true
  onCleanup(() => { mounted = false })
  createEffect(() => { props.href; setStore({ copied: false, failed: false }) })
  createEffect(() => {
    if (!store.copied) return
    const timer = setTimeout(() => setStore("copied", false), 2000)
    onCleanup(() => clearTimeout(timer))
  })
  const copy = async () => {
    const path = props.href
    try {
      await navigator.clipboard.writeText(new URL(path, window.location.origin).href)
      if (mounted && path === props.href) setStore({ copied: true, failed: false })
    } catch {
      if (mounted && path === props.href) setStore({ copied: false, failed: true })
    }
  }
  return <span class="report-preview-links">
    <Show when={!props.review}><a href={props.href} target="_blank" rel="noopener noreferrer">{language.t("cowork.report.workspace.open")} ↗</a></Show>
    <button type="button" onClick={() => void copy()}>{language.t(store.copied ? "cowork.report.workspace.copied" : props.review ? "cowork.approval.workspace.copyLink" : "cowork.report.workspace.copy")}</button>
    <Show when={store.failed}><span role="alert">{language.t("cowork.report.workspace.copyError")}</span></Show>
    <span class="sr-only" role="status">{store.copied ? language.t("cowork.report.workspace.copied") : ""}</span>
  </span>
}
